export const licenseKey =
  "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjMyOTU3ZmFhLTMxNTctNDdmNy1iMmJmLWJhYzI2M2U2MGFjOSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.OQuHZK9XZrSL2SThhp4AhK7hWA+RbLrGNJ2B0fjoQyvpR5eYJVEalsACGCFVHanTWxJCu8kCJhaoWgNRjHGPYT2TYgW98maxkLAwRUm0NPJcV9T8ErNXxkT9nHtihcB1LJYZbQ==";
